import { c as _c } from "react/compiler-runtime";
import { MathLib } from '@morpho-org/blue-sdk';
import { Donut, getDonutColor } from '@morpho-org/ui-v6/server';
import { formatters } from '@morpho-org/ui-v6/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui';
import { memo, useMemo } from 'react';
import { formatUnits } from 'viem';
import { getShareFromTotal } from '@/helpers/vault';
import { CAP_DONUT_RADIUS } from './VaultV2CapDonutSpacer';
interface VaultV2RelativeCapCellProps {
  relativeCap: bigint;
  allocation: bigint;
  totalAssets: bigint;
  index: number;
}
function VaultV2RelativeCapCell(t0) {
  const $ = _c(26);
  const {
    relativeCap,
    allocation,
    totalAssets,
    index
  } = t0;
  let t1;
  if ($[0] !== relativeCap) {
    t1 = formatters.percent.default("0").trailingZero(false).digits(2).unit("%").of(relativeCap, 18);
    $[0] = relativeCap;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formattedRelativeCap = t1;
  let t2;
  if ($[2] !== allocation || $[3] !== relativeCap || $[4] !== totalAssets) {
    const absoluteCapLimit = MathLib.wMulDown(relativeCap, totalAssets);
    t2 = getShareFromTotal(absoluteCapLimit, allocation);
    $[2] = allocation;
    $[3] = relativeCap;
    $[4] = totalAssets;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const percentShare = t2;
  let t3;
  if ($[6] !== percentShare) {
    t3 = formatUnits(percentShare, 18);
    $[6] = percentShare;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const percentShareNumber = Number(t3) * 100;
  let t4;
  bb0: {
    if (percentShareNumber >= 100) {
      t4 = "var(--color-warning-foreground)";
      break bb0;
    }
    let t5;
    if ($[8] !== index) {
      t5 = getDonutColor(index);
      $[8] = index;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    t4 = t5;
  }
  const donutColor = t4;
  let t5;
  if ($[10] !== percentShare) {
    t5 = formatters.percent.default("0").digits(2).unit("%").of(percentShare, 18);
    $[10] = percentShare;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const formattedPercentFilled = t5;
  let t6;
  if ($[12] !== donutColor || $[13] !== percentShareNumber) {
    t6 = <TooltipTrigger asChild={true}><div className="flex cursor-default"><Donut allocation={percentShareNumber} color={donutColor} backgroundColor="var(--color-muted)" radius={CAP_DONUT_RADIUS} /></div></TooltipTrigger>;
    $[12] = donutColor;
    $[13] = percentShareNumber;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = `${formattedPercentFilled} filled`;
  let t8;
  if ($[15] !== t7) {
    t8 = <TooltipContent>{t7}</TooltipContent>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <Tooltip>{t6}{t8}</Tooltip>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      lineHeight: "normal"
    };
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== formattedRelativeCap) {
    t11 = <span className="text-2xs text-foreground" style={t10}>{formattedRelativeCap}</span>;
    $[21] = formattedRelativeCap;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t9) {
    t12 = <div className="gap-xs flex items-center">{t9}{t11}</div>;
    $[23] = t11;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
}
export default memo(VaultV2RelativeCapCell);